<template>
  <div ref="root" class="component--custome-menu" :class="{ 'menu-collapsed': isCollapse }">
    <div class="title" v-if="false">{{ menus.title }}</div>
    <div class="menus-wrapper">
      <el-menu
        :default-active="$route.path"
        mode="vertical"
        @select="handleMenuItemClick"
        :collapse="isCollapse"
        :collapse-transition="false"
        class="el-menu-main"
      >
        <template v-for="menu in menuObject">
          <el-submenu
            v-if="menu.hasChild"
            :popper-append-to-body="false"
            :key="menu.id"
            :index="menu.url" 
            :class="[
              comparePath($route.path,menu.url) ? 'selected current-menu' : '',
              menu.hasChild ? 'parent' : null,
            ]"
          >
            <template slot="title">
              <svg-icon v-if="!!menu.icon" class="menu-icon" :icon="menu.icon" ></svg-icon>
              <span slot="title" class="menu-title">{{ menu.name }}</span>
            </template>
            <el-menu-item
              v-for="cMenu in menu.children"
              :key="cMenu.id"
              :index="cMenu.url" 
              @click="handleMenuItemClick(cMenu, $event)"
              class="menu-item-children"
            >
              {{ cMenu.name }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :index="menu.url" :key="menu.id" @click="handleMenuItemClick(menu, $event)">
            <svg-icon v-if="!!menu.icon" class="menu-icon" :icon="menu.icon"></svg-icon>
            <span class="menu-title" slot="title">{{ menu.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { waveRippleAtClickHandler } from "../utils/domHelper";
export default {
  props: {
    title: {
      type: String,
    },
    menus: {
      type: Array,
    },
    routeRender: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      hoverMenu: null,
      visible:true,
    };
  },
  computed: {
    menuObject() {
      const menus = this.menus || [];
      const result = menus.map((m) => ({
        ...m,
        hasChild: !!m.children && m.children.length > 0,
        expened: false,
        children: !!m.children ? m.children.map((cm) => ({ ...cm })) : null,
      }));
      return result;
    },
    isCollapse(){
      return this.$store.getters.getIsCollapse;
    }
  },
  watch: {
    menus(newVal, oldVal) {
      if (!!newVal && !oldVal) {
        this.findMatchedItemAndFocus();
      }
    },
  },
  methods: {
    waveRippleAtClickHandler,
    async handleMenuItemClick(menu, ev) {
      if(typeof menu === 'string'){
        let menuObj = this.menus.find(item => item.url == menu+'');
        if(!menuObj){
          menu={url:menu,hasChild:false};
        }else{
          menu=menuObj;
        }
      }
      waveRippleAtClickHandler(ev);
      if (!!menu.hasChild) {
        menu.expened = !menu.expened;
      } else {
        let isPathSame = this.$route.path+''== menu.url+'';
        if (!isPathSame) {
          const targetRoute = await this.routeRender(menu.url);
          this.$router.replace(targetRoute);
        }
      }
      this.$forceUpdate();
    },
    findMatchedItemAndFocus() {
      let matchedMenuItem, matchedParentMenuItem;
      for (const menu of this.menuObject) {
        if (this.comparePath(this.$route.path,menu.url)) {
          matchedMenuItem = menu;
          break;
        }

        for (const childMenu of menu.children || []) {
          if (this.comparePath(this.$route.path,childMenu.url)) {
            matchedMenuItem = childMenu;
            matchedParentMenuItem = menu;
          }
        }
        if (!!matchedMenuItem) break;
      }

      if (!!matchedParentMenuItem) {
        matchedParentMenuItem.expened = true;
      }
      if (matchedMenuItem) {
        this.$forceUpdate();
        this.$nextTick(() => {
          const selectedItemEl = document.querySelector(".current-menu");
          selectedItemEl &&
            this._testScrollNeeded(selectedItemEl) &&
            selectedItemEl.scrollIntoView();
        });
      }
    },

    comparePath(refPath, basePath) {
      return (
        refPath == basePath || refPath.startsWith(basePath + "/")
      );
    },
    _testScrollNeeded(el) {
      const root = this.$refs.root;
      let scrollParent = null;
      if (!el || !root || !(scrollParent = root.offsetParent)) return;

      const scrollParentRect = scrollParent.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      return (
        elRect.bottom <= scrollParentRect.top || el.top >= scrollParent.bottom
      );
    },
  },
  mounted() {
    this._removeAfterHook = this.$router.afterEach((to, from) => {
      this.findMatchedItemAndFocus();
    });
    this.findMatchedItemAndFocus();
  },
  beforeDestroy() {
    this._removeAfterHook && this._removeAfterHook();
  },
};
</script>

<style lang="scss">
.menu-collapsed{
  padding: 8px !important;
}
.component--custome-menu {
  font-size: 15px;
  overflow: auto;
  height: calc(100% - 60px);
  color: #7F7F7F;
  
  overflow-x: hidden;
  padding: 12px;
  user-select: none;

  .el-menu--vertical{
    position: fixed !important;
    left:90px !important;

    .el-menu{
      background: linear-gradient(135deg, rgb(89, 101, 249) 0, #8039ca 100%) !important;
      width: 140px; 
      min-width: 120px;
      .el-menu-item{
        min-width: 110px;
        margin-left: 10px;
        margin-right: 10px;
        padding: 0;
      }
    }
  }
  
  .title {
    color: #7F7F7F;
    text-align: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #cccccc;
  }
  .menu-item-children{
    margin-left: 15px;
  }
  .menus-wrapper {
    .el-menu{
      background-color: unset;
      border-right: none;
      .el-menu-item,.el-submenu__title{
        color: rgba(255, 255, 255, 0.7);
        border-radius: 0.5rem;
        white-space: unset;
        font-size: 0.925rem;
        margin-bottom: 6px;
        height: 50px;
        line-height: 45px;
        i,.menu-icon {
            color: rgba(255, 255, 255, 0.7);
        }
      }
      .el-menu-item:hover,.el-submenu__title:hover{
        background: rgba(255, 255, 255, .1);
        color: white;
        i,.menu-icon {
          color: white;
        }
      }
      .el-menu-item.is-active {
        background: rgba(255, 255, 255, .1);
        color: white;
        i,.menu-icon  {
          color: white;
        }
      }

      .menu-icon {
        margin-inline-end: 0.875rem;
        font-size: 1.3rem;
        vertical-align: middle;
      }
    }
  }

  li {
    list-style: none;
  }
}
</style>
